<template>
  <v-container data-aos="fade">
    <v-layout row wrap justify-space-around>
      <v-flex xs12 sm4 class="text-center">
        <v-img :src="image" class="elevation-2 flyer"></v-img>
        <v-btn color="primary"
          href="mailto:contact@chefnaturelle.com?subject=Beet the January Blues"
        >Book Now</v-btn>
      </v-flex>
      <v-flex xs12 sm7>
        <h1>Beet the January Blues</h1>
        <v-layout class="pricing-details" row justify-space-between>
          <v-flex xs8 class="text-xs-left">
            Saturday 25th January 2020 - 7pm to 10pm - Hertford
          </v-flex>
          <v-flex xs4 class="text-xs-right">
            £35
          </v-flex>
        </v-layout>
        <p class="font-weight-bold">
          Stéphanie is delighted to be coming back to
          <a href="https://mudlarksgarden.org.uk/cafe/" target="_blank">Mudlarks Garden Café</a>
          for the first Farm to Table dinner of 2020.
        </p>

        <p class="font-weight-bold">Whether you are following a plant-based diet, doing "veganuary" or just fancy a
          lovely meal out, you will be treated with a three-course meal featuring beautiful produce sourced from a
          local farm and our allotment.
        </p>

        <p>
          <b>The evening will start at 7pm with a welcome drink and amuse-bouche.</b>
          You will have a little time to get comfy and get to know the other guests before finding your seat and
          discovering the set menu.
          <b>The menu*, finalised closer to the date to make the most of the season, will showcase local and
            seasonal produce.</b>
        </p>

        <p>
          <b>The event is Bring Your Own.</b>
          Stéphanie has teamed up with local wine specialist
          <a href="https://www.cavavin.co.uk" target="_blank">Cavavin</a> in Hertford who have selected matching
          wines to compliment the menu. They will be available to buy from their shop with full details and
          tasting notes provided upon booking. You are also welcome to bring other alcoholic or non-alcoholic drinks.
        </p>
        <p>Tickets are £35 per person and include a welcome drink, amuse-bouche and a three-course meal.</p>
        <p class="font-weight-bold">Spaces are strictly limited, booking is essential - please email Stéphanie
          <Contact subject="Beet the January Blues"></Contact>.
        </p>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-space-around mt-5>
      <v-flex>
        <p>What people have said:</p>
        <p><i>"My first vegan tasting dinner! It was "bloody delicious"! Chef Naturelle, you absolutely nailed it! I love
          the use of local ingredients and innovative concepts, especially the damson plum tart."</i>
          - Tara
        </p>
        <p><i>"Last night, the sweet and talented Chef Naturelle welcomed us into Mudlarks Garden Cafe for a seasonal
          plant-based 3-course meal. The amount of love and energy that went into last night was pretty amazing.
          Stephanie grows veg in her allotment and sources her ingredients from local farms. We are very much inspired
          and can't wait for the next supperclub!"</i>
          - Nicole &amp; Joe
        </p>
        <p>
          <i>"I'm not vegan. In fact, I usually ignore vegan options whenever I look at a menu. However, Stéphanie's
            cooking has completely changed my thinking. She has a unique talent of using natural ingredients to
            create extraordinary dishes and coupled with the wonderful atmosphere, it is an event you will be sorry
            to miss.</i>
          - Darren
        </p>
        <div class="terms">
          <p>
            * If you have any dietary requirements or food intolerances, please
            <contact-link subject="Beet the January Blues"></contact-link> and we will tailor the dishes to suit your
            needs. Unfortunately, this event is not suitable for anyone suffering from food allergies as the food is
            freshly prepared in a kitchen which uses wheat, rye, barley, oats, nuts (including peanuts), seeds
            (including sesame), soybeans and other allergens.
          </p>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ContactLink from '@/components/ContactLink'
import Contact from '@/components/Contact'

export default {
  components: {
    Contact,
    ContactLink
  },
  data: () => ({
    image: require('@/assets/images/beet-the-january-blues-flyer.jpg?vuetify-preload')
  })
}
</script>

<style scoped>
h1 {
  color: rgb(4,51,255);
  font-family: 'Karla', sans-serif;
  font-weight: bold;
  text-transform: none;
  font-size: 40px;
  text-align: center;
}

.flyer {
  margin-bottom: 15px;
}

.underline {
  text-decoration: underline;
}

.terms p {
  font-size: 13px;
  font-style: italic;
}

.pricing-details {
  color: rgb(4,51,255);
  border-bottom: 1px solid rgb(4,51,255);
  margin-bottom: 23px;
  padding-bottom: 20px;
  text-transform: uppercase;
  font-weight: bold;
}

.v-image {
  margin-top: 14px;
}

strong {
  color: rgb(4,51,255);
  font-size: 25px;
}
</style>
